// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"044f5a54","453":"ed0560ec","661":"8736c6b5","816":"23a85c62","866":"20747edf"}[chunkId] + ".chunk.js";
};